$(document).on(
    'change',
    'form[data-session!="false"] input[type!="password"][data-session!="false"], ' +
    'form[data-session!="false"] select[data-session!="false"], ' +
    'form[data-session!="false"] textarea[data-session!="false"], ' +
    'input[type!="password"][data-session="true"],' +
    'select[data-session="true"]' +
    'textarea[data-session="true"]', function () {

        // Retrieve specific form token if available.
        let formToken = $(this).parents('form').find('input[name="_token"]');
        if (formToken.length === 1) {
            let formHeaders = {'X-CSRF-TOKEN': $(formToken).val()};
            $.post({
                url: '/form-session',
                dataType: 'JSON',
                headers: formHeaders,
                data: {
                    field: this.name,
                    type: this.type,
                    value: this.value
                }
            });
        } else {
            $.post({
                url: '/form-session',
                dataType: 'JSON',
                data: {
                    field: this.name,
                    type: this.type,
                    value: this.value
                }
            });
        }
    });

$(document).on('click', '.cancelForm', function (e) {
    e.preventDefault()
    $.get({
        url: '/form-session', success: () => {
            window.location.href = this.href;
        }
    })
});
